<template>
    <VListItemContent v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot />
    </VListItemContent>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-list-item-content';

export default {
    name: 'SrListItemContent',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
